import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { AiOutlineArrowRight } from 'react-icons/ai';
// import contact data
import { contact } from '../data';
import swal from 'sweetalert';
import { Zoom } from 'react-reveal';
import Flash from 'react-reveal/Flash';
import RubberBand from 'react-reveal/RubberBand';


const Contact = () => {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_dml7lyi', 'template_j45bwzu', e.target, 'wdT4zt6LdX8GyA82Y')
      .then((result) => {
        swal("Successfull", "You Send an Email!", "success");
        e.target.reset();
      }, (error) => {
        swal("OPPSS...", "Email not Send!", "error");
      });
  };

  return (
    <section className='section bg-primary' id='contact'>
      <div className='container mx-auto'>
        <RubberBand>
          <div className='flex flex-col items-center text-center'>
            <h2 className='section-title before:content-contact relative before:absolute before:opacity-40 before:-top-7 before:-left-40 before:hidden before:lg:block'>
              Contact me
            </h2>
            <p className='subtitle'>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga veniam
              labore nisium illum cupiditate reiciendis a numquam
            </p>
          </div>
        </RubberBand>
        <div
          className='flex flex-col lg:gap-x-8 lg:flex-row'
        >
          <div
            className='flex flex-1 flex-col items-start space-y-8 mb-12 lg:mb-0 lg:pt-2'
          >
            {contact.map((item, index) => {
              const { icon, title, subtitle, phone, description } = item;
              return (
                <div className='flex flex-col lg:flex-row gap-x-4' key={index}>
                  <div className='text-accent rounded-sm w-14 h-14 flex items-start justify-center mt-2 mb-4 lg:mb-0 text-2xl'>
                    {icon}
                  </div>
                  <Flash>
                    <div>
                      <h4 className='font-body text-xl mb-1'>{title}</h4>
                      <p className='mb-1 text-paragraph'>{subtitle}</p>
                      <a target="_blank" href="tel:01636090316" rel="noopener noreferrer" className=""><p className='text-accent font-normal '>{phone}</p></a>
                      <a target="_blank" href="mailto:moazzemhossainnahid@gmail.com" rel="noopener noreferrer" className=""><p className='text-accent font-normal '>{description}</p></a>

                    </div>
                  </Flash>
                </div>
              );
            })}
            <div className="text-center flex md:justify-center w-full mx-auto">
              <a href="https://calendly.com/moazzemhossainnahid/web" className="" target="_blank" rel="noreferrer">
                <button className="flex items-center gap-1 btn btn-sm btn-outline border border-rose-700 group">Schedule a Meeting <AiOutlineArrowRight className='pt-1 text-2xl group-hover:translate-x-3 duration-300 ease-out' /> </button>
              </a>
            </div>
          </div>
          <Zoom duration={1500} top>
            <form
              ref={form} onSubmit={sendEmail}
              className='space-y-8 w-full max-w-[780px]'
            >
              <div className='flex flex-col md:flex-row gap-8'>
                <input required name='name' className='input bg-[#1C1D24]' type='text' placeholder='Your name' />
                <input required name='email' className='input bg-[#1C1D24]' type='email' placeholder='Your email' />
              </div>
              <input required name='subject' className='input bg-[#1C1D24]' type='text' placeholder='Subject' />
              <textarea
                required
                name='message'
                className='textarea bg-[#1C1D24]'
                placeholder='Your message'
              ></textarea>
              <button type='submit' className='btn btn-lg bg-accent hover:bg-secondary-hover'>
                Send message
              </button>
            </form>
          </Zoom>
        </div>
      </div>
    </section>
  );
};

export default Contact;
